import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BucketWebService } from './bucket-web.service';

export interface BaseNode {
  readonly id: string;
  name: string;
  readonly size: number;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly idUtenteCreazione: string;
  readonly parentPath: string;
  readonly path: string;
}

export interface FileNode extends BaseNode {
  readonly gcsPath: string;
  readonly contentType: MimeType;
  readonly extension?: FileExtension;
}

export interface FolderNode extends BaseNode {
  readonly idUtenteUltimaModifica: string;
  readonly tags: string[];
  folders: FolderNode[];
  files: FileNode[];
  readonly locked: boolean;
  fileCounter: number;
}

export type FileExtension = 'pdf' | 'xlsx' | 'doc' | 'odt' | 'json' | 'txt' | 'docx';

export const fileExtension: FileExtension[] = ['pdf', 'xlsx', 'doc', 'odt', 'json', 'txt', 'docx'];

export const fileColorMap: Record<FileExtension, string> = {
  pdf: '#ffdddd',
  xlsx: '#ddffdd',
  doc: '#ddeeff',
  docx: '#ddeeff',
  odt: '#ddeeff',
  json: '#ffffcc',
  txt: '#f5f5f5',
};

export type MimeType =
  | 'application/pdf' // .pdf
  | 'application/vnd.ms-excel' // .xls
  | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // .xlsx
  | 'application/msword' // .doc
  | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // .docx
  | 'application/vnd.oasis.opendocument.text' // .odt
  | 'application/json' // .json
  | 'text/plain'; // .txt

export const allowedTypes: MimeType[] = ['application/pdf'];
@Injectable({
  providedIn: 'root',
})
export class BucketService {
  constructor(
    private readonly _bucketWebService: BucketWebService,
    private readonly _dialog: MatDialog,
  ) {}

  getLogoFile(extension: FileExtension | undefined): string {
    switch (extension) {
      case 'pdf':
        return 'assets/images/file-manager-logo/pdf.png';
      case 'doc':
      case 'odt':
      case 'docx':
        return 'assets/images/file-manager-logo/doc.png';
      case 'json':
        return 'assets/images/file-manager-logo/json.png';
      case 'txt':
        return 'assets/images/file-manager-logo/txt.png';
      case 'xlsx':
        return 'assets/images/file-manager-logo/xls.png';

      default:
        return '';
    }
  }

  public getListaFolders() {
    return this._bucketWebService.getListaFolders();
  }

  public deleteFolderByIdApi(idFolder: string) {
    return this._bucketWebService.deleteFolderById(idFolder);
  }
  public deleteFileByIdApi(idFile: string) {
    return this._bucketWebService.deleteFileById(idFile);
  }

  public createFolderApi(parentPath: string, nomeFolder: string) {
    return this._bucketWebService.createFolder(parentPath, nomeFolder);
  }
  public updateFolderApi(nomeFolder: string, idFolder: string) {
    return this._bucketWebService.updateFolder(nomeFolder, idFolder);
  }

  public getDownloadFile(idFile: string) {
    return this._bucketWebService.getDownloadFile(idFile);
  }

  public updateFileName(nomeFile: string, idFile: string) {
    return this._bucketWebService.updateFileName(nomeFile, idFile);
  }

  public getFoldersForModuli(idModulo: string | null) {
    return this._bucketWebService.getFoldersForModuli(idModulo);
  }
}
